<template>
  <div :class="['language-picker', `language-picker--${size}`]">
    <oie-base-button
      v-for="(item, i) in languages"
      :key="i"
      is-type="a"
      :text="item.title"
      css-classes="language-picker__item button-link button-link--ghost"
      :url="item.pageUrl">
      <template v-slot:icon>
        <oie-base-image
          :images="item.imageUrl"
          :alt-text="item.title"
          image-width="20px"
          image-height="20px"></oie-base-image>
      </template>
    </oie-base-button>
  </div>
</template>

<script>
export default {
  props: {
    languages: {
      type: Array,
      default: () => []
    },
    size: {
      type: String,
      default: 'large'
    }
  }
}
</script>

<style lang="scss">
.language-picker {
  display: flex;
  flex-direction: column;
  margin-bottom: 20px;
  gap: measure(quarter);
}

// .language-picker--large {
//   max-width: 600px;
// }

// .language-picker--small {
//   max-width: 300px;
// }

.language-picker__item {
  justify-content: flex-start;
  gap: measure(quarter);

  img {
    width: 20px;
    height: 20px;
  }
}
</style>
